import clsx from 'clsx'
import React from 'react'

interface FeatureListItemProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  coverage: React.ReactNode;
  label: React.ReactNode;
  topAlign?: boolean;
}

export function FeatureListItem ({ coverage, label, topAlign = false, ...props }: FeatureListItemProps) {
  return (
    <div
      {...props} className={clsx('flex gap-2', {
        'items-center': !topAlign,
        'items-start': topAlign,
      })}
    >
      <dt className='text-gray-800 font-normal text-nowrap'>{label}</dt>
      {!topAlign && <span aria-hidden className='dotted-line grow' />}
      {topAlign && <div aria-hidden className='dotted-line grow mt-3' />}
      <dd className='text-gray-800 font-semibold max-w-[50%] text-wrap-balance text-right'>{coverage}</dd>
    </div>
  )
}

FeatureListItem.displayName = 'FeatureList.Item'
